import React from 'react';
import MyWorkshopsHeader from './MyWorkshopsHeader';
import MyWorkshopsList from './MyWorkshopsList';
import JobBoardPagination from '../../../JobBoard/JobBoardPagination';

const MyWorkshops = ({
  workshopsList,
  likedWorkshopsList,
  onLikeDeleteSuccess,
  onExpire,
  onCancelClick,
  current,
  totalPages,
  onPageChange,
  currentFilter,
  onFilterChange,
  hasAnyWorkshop,
}) => {
  return (
    <div className='flex flex-col w-full items-start'>
      <MyWorkshopsHeader
        currentFilter={currentFilter}
        onFilterChange={onFilterChange}
        workshopsList={workshopsList}
        hasAnyWorkshop={hasAnyWorkshop}
      />
      <MyWorkshopsList
        currentFilter={currentFilter}
        workshopsList={workshopsList}
        likedWorkshopsList={likedWorkshopsList}
        onLikeDeleteSuccess={onLikeDeleteSuccess}
        onExpire={onExpire}
        onCancelClick={onCancelClick}
      />
      {workshopsList.length > 0 && (
        <JobBoardPagination
          current={current}
          totalPages={totalPages}
          onPageChange={onPageChange}
          isMyPage
        />
      )}
    </div>
  );
};

export default MyWorkshops;
